<template>
    <div id="app">
        <Header/>
        <router-view/>
        <Footer/>
    </div>
</template>

<script>
    import Header from '@/components/layout/Header'
    import Footer from '@/components/layout/Footer'

    export default {
        name: 'app',
        components: {
            Header,
            Footer,
        },
    }
</script>

<style scoped>
    #app {
        font-family: Avenir, Helvetica, Arial, sans-serif;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        color: #2c3e50;
    }

    #nav {
        padding: 30px;
    }

    #nav a {
        font-weight: bold;
        color: #2c3e50;
    }

    #nav a.router-link-exact-active {
        color: #42b983;
    }

</style>

<style>
  .popover-header {
    width: 500px !important;
    height: 500px;
    overflow-y: scroll;
  }
</style>
